import { render, staticRenderFns } from "./TopTrendingVideos.vue?vue&type=template&id=37d123ca&scoped=true"
import script from "./TopTrendingVideos.vue?vue&type=script&lang=js"
export * from "./TopTrendingVideos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d123ca",
  null
  
)

export default component.exports